/* ZWEVEND — Thema v2 ronde 3 (29-10-2026, besluit "Zwevende knoppen: optie 1, WhatsApp-variant 1").
   1. WhatsApp-knop (app-embed ca-whatsapp-button) schuift met transform mee omhoog boven de hoogste vaste
      laag onderaan het scherm (koopbalk, cookiebalk, meldingen, voorbeeldbalk): bodem knop = bovenkant
      laag + 10 px. Geen vaste getallen: de lagen worden gemeten bij scrollen, resize, DOM-wijzigingen en
      transitionend. CSS (ZWEVEND in lodyfair-base.css) zet de knop op 16 px van de hoek en animeert
      --lf-zweef-op in 300 ms.
   2. Een schermvullende laag (popup, maattabel) → html.lf-zweef-weg: knop weg.
   3. De ladderregel in de koopbalk ([data-lf-koopbalk-ladder]) uit de lade-telling. */
(function () {
  var root = document.documentElement;
  var BASIS = 16, MARGE = 10, gepland = false;
  var BEKEND = '.lf-koopbalk, #shopify-pc__banner, #PBarNextFrameWrapper, .lf-toast, [data-lf-toast], [role="status"].is-zichtbaar, .shopify-pc__banner__dialog, [role="dialog"][aria-modal="true"]';

  function widget() { return document.getElementById('whatsapp-floating-widget') || document.querySelector('.whatsapp-floating-widget'); }
  /* geen el.hidden-toets: de koopbalk draagt altijd hidden en wordt met display:block !important getoond */
  function zichtbaar(el, s) { return s.display !== 'none' && s.visibility !== 'hidden' && +s.opacity > 0.05; }

  function meet() {
    gepland = false;
    var w = widget(), vh = window.innerHeight, vw = window.innerWidth;
    var kandidaten = Array.prototype.slice.call(document.body.children).concat(Array.prototype.slice.call(document.querySelectorAll(BEKEND)));
    var hoogste = vh, vol = false;
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];
      if (!el || el === w || (w && (el.contains(w) || w.contains(el)))) continue;
      var s = getComputedStyle(el);
      if (s.position !== 'fixed' || !zichtbaar(el, s)) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 8 || r.height < 8 || r.top >= vh || r.bottom <= 0) continue;
      if (r.height >= vh * 0.9 && r.width >= vw * 0.9) {
        /* schermvullend: alleen tellen als het echt iets toont (Klaviyo laat een lege houder staan) */
        if (el.getAttribute('aria-modal') === 'true' || el.matches('[role="dialog"]')) vol = true;
        continue;
      }
      if (r.bottom < vh - 4) continue;            /* raakt de onderkant niet: geen laag onderaan */
      if (r.top < vh * 0.25) continue;            /* lade/menu van boven tot onder: die heeft eigen regels */
      if (r.top < hoogste) hoogste = r.top;
    }
    var op = Math.max(0, Math.round((vh - hoogste) + MARGE - BASIS));
    if (vh - hoogste === 0) op = 0;
    root.style.setProperty('--lf-zweef-op', op + 'px');
    root.classList.toggle('lf-zweef-weg', vol);
  }
  function plan() { if (!gepland) { gepland = true; requestAnimationFrame(meet); } }

  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan, { passive: true });
  document.addEventListener('transitionend', plan);
  document.addEventListener('lf:cart:ververst', plan);
  new MutationObserver(plan).observe(document.body, { childList: true, attributes: true, subtree: false });
  var balk = document.querySelector('[data-lf-koopbalk]');
  if (balk) new MutationObserver(plan).observe(balk, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
  if (window.ResizeObserver && balk) new ResizeObserver(plan).observe(balk);
  /* apps (cookiebalk, Klaviyo) zetten zich later neer: de eerste seconden extra meten */
  [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(plan, t); });
  plan();

  /* ---------- ladderregel in de koopbalk ---------- */
  var regel = document.querySelector('[data-lf-koopbalk-ladder]');
  if (!regel) return;
  function geld(c) {
    var h = Math.floor(c / 100), r = c % 100;
    return '€' + String(h).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (r < 10 ? '0' + r : r);
  }
  function ladder() {
    var d1 = +regel.dataset.d1 || 8000, d2 = +regel.dataset.d2 || 15000, tier2 = regel.dataset.tier2 === '1', en = regel.dataset.en === '1';
    var l = document.querySelector('[data-lf-ladder]');
    var telt = l ? (+l.dataset.telt || 0) : 0;
    var t;
    if (tier2 && telt >= d2) t = en ? 'Nike socks and Calvin Klein 3-pack are free.' : 'Nike sokken en Calvin Klein 3-pack zijn gratis.';
    else if (telt >= d1 && tier2) t = (en ? '<strong>' + geld(d2 - telt) + '</strong> to go for a free Calvin Klein 3-pack' : 'Nog <strong>' + geld(d2 - telt) + '</strong> tot je gratis Calvin Klein 3-pack');
    else if (telt >= d1) t = en ? 'Nike socks are free.' : 'Nike sokken zijn gratis.';
    else t = (en ? '<strong>' + geld(d1 - telt) + '</strong> to go for free Nike socks' : 'Nog <strong>' + geld(d1 - telt) + '</strong> tot je gratis Nike sokken');
    regel.innerHTML = t;
    regel.hidden = false;
    plan();
  }
  document.addEventListener('lf:cart:ververst', ladder);
  ladder();
})();
